// 共享的展示小件：栏目眉标、卡片标签、分类色映射
import type { ReactNode } from "react";

export type Tone = "primary" | "accent" | "secondary";

const toneStyles: Record<Tone, string> = {
  primary: "bg-primary-100 text-primary-700",
  accent: "bg-accent-100 text-accent-800",
  secondary: "bg-secondary-100 text-secondary-800",
};

export function Tag({ tone = "secondary", children }: { tone?: Tone; children: ReactNode }) {
  return (
    <span className={`inline-flex items-center whitespace-nowrap rounded-full px-2.5 py-1 text-[11px] font-medium leading-none ${toneStyles[tone]}`}>
      {children}
    </span>
  );
}

export function SectionHead({
  eyebrow,
  title,
  sub,
  tone = "primary",
  align = "left",
}: {
  eyebrow: string;
  title: string;
  sub?: string;
  tone?: Tone;
  align?: "left" | "center";
}) {
  const barColor = tone === "accent" ? "bg-accent-500" : tone === "primary" ? "bg-primary-500" : "bg-secondary-500";
  return (
    <div className={`mb-6 md:mb-9 ${align === "center" ? "text-center" : "text-left"}`}>
      <div className={`flex items-center gap-2 ${align === "center" ? "justify-center" : ""}`}>
        <span className={`h-4 w-1 rounded-full ${barColor}`} />
        <span className="text-xs font-medium uppercase tracking-[0.2em] text-foreground-500">{eyebrow}</span>
      </div>
      <h2 className="font-heading mt-3 text-2xl font-bold leading-tight text-foreground-950 md:text-[2rem] md:leading-tight">
        {title}
      </h2>
      {sub && <p className="mt-3 max-w-2xl text-sm leading-7 text-foreground-600 md:text-[15px]">{sub}</p>}
    </div>
  );
}

export function readAvatar(name: string) {
  return name.slice(0, 1);
}